import { ChangeCatalog } from './../../catalog.model';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DictionaryEntry } from '@sdbn/common';
import { AppServerAPI } from '@sdbn/common';

@Component({
    selector: 'app-change-catalog-dialog',
    templateUrl: './change-catalog-dialog.component.html',
    styleUrls: ['./change-catalog-dialog.component.scss'],
    standalone: false
})
export class ChangeCatalogDialogComponent implements OnInit {

  name = new DictionaryEntry();
  catalogId: number;

  constructor(
    public dialogRef: MatDialogRef<ChangeCatalogDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private appServerAPI: AppServerAPI
  ) {
    this.name = data.catalog.name;
    this.catalogId = data.catalog.id;
    // ...



  }

  ngOnInit(): void {
  }

  onClose() {
    this.dialogRef.close();
  }

  onConfirm() {
    console.log('call changeCatalog', this.name);
    this.appServerAPI.execute<number>('/client/erp-article/catalog/changeCatalog', new ChangeCatalog({ catalogId: this.catalogId, name: this.name })).subscribe(response => {

      console.log('response is', response);

      this.dialogRef.close();

    }, error => {
      console.log('error is', error);
    });
  }

  confirmDisabled(): boolean {
    return this.name == null || !this.name.checkValueExistsForLanguage('de');
  }

  public onNameChanged(dictionaryEntry: DictionaryEntry) {
    this.name = dictionaryEntry;
  }

}
